import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { ROUTES } from "config";
import EmployeeWorkspace from "pages/EmployeeWorkspace";

export default function MyDataSheetRedirect() {
    const { initialized, isAuthenticated } = useSelector((state) => state.auth);

    const profile = useSelector((state) => state.user.profile);

    if (!initialized) {
        return null;
    }

    const personId = profile?.personId;
    if (personId) {
        return <EmployeeWorkspace personId={personId} />;
        /* return (
             <Navigate
                 to={isAuthenticated ? ROUTES.EMPLOYEE(personId) : ROUTES.LOGIN}
                 replace
             />
         );*/
    }

    return (
        <Navigate
            to={isAuthenticated ? ROUTES.DASHBOARD : ROUTES.LOGIN}
            replace
        />
    );
}
